// extracted by mini-css-extract-plugin
module.exports = {"content":"PracticeDropdown_content__1v0PU","main":"PracticeDropdown_main__34bZ7","sub":"PracticeDropdown_sub__1sO_l","menu":"PracticeDropdown_menu__39A8J"};